declare global {
  interface Window {
    heap: any;
  }
}

const getHeap = (): any =>
  typeof window !== "undefined" ? window.heap : undefined;

export const HeapService = {
  identify(identity: string): void {
    getHeap()?.identify?.(identity);
  },

  resetIdentity(): void {
    getHeap()?.resetIdentity?.();
  },

  getIdentity(): string | undefined {
    return getHeap()?.getIdentity?.();
  }
};
